import styled from 'styled-components';

export const EditorContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;
  min-height: 400px;
  background-color: white;
  padding-bottom: 10px;
`;

export const ContentSection = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  padding-right: 15px;
  padding-left: 15px;
`;

export const EditorHeading = styled.h6`
  padding-top: 1rem !important;
  padding-bottom: 0.25rem !important;
  text-align: center;
`;

export const PreviewSection = styled.h6`
  border: 1px solid #ccc;
  min-height: 100px !important;
  overflow: hidden;
  overflow-x: auto;
  padding: 20px;
`;
